import { Button, Form, message, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import SupplementForm from "./Supplement-Form";
import useSupplements from "hooks/useSupplements";
const EditSupplementModal = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state.modals
  );
  const open = isModalOpen && modalType === "edit_supplement"; // <-- Déplacer ici
  const {
    getSupplementById,
    updateSupplement,
    Supplement,
    setSupplement,
    isLoading,
    error,
    setError,
  } = useSupplements();
  const [isSendForUpdate, setIsSendForUpdate] = useState(false);

  useEffect(() => {
    if (open && modalProps?.supplementId) {
      const fetchData = async () => {
        try {
          await getSupplementById(modalProps.supplementId);
        } catch (error) {
          message.error(t("supplements.load.error"));
        }
      };
      fetchData();
    }
  }, [open, modalProps?.supplementId]);

  // Corrigez le useEffect de mise à jour du formulaire :
  useEffect(() => {
    if (Supplement && !isLoading) {
    
      form.setFieldsValue({
        name: Supplement.name,
        price: parseFloat(Supplement.price),
        description: Supplement.description,
        entryDate: Supplement.entryDate ? dayjs(Supplement.entryDate) : null,
        exitDate: Supplement.exitDate ? dayjs(Supplement.exitDate) : null
      });
    }
  }, [Supplement, isLoading, form]);

  useEffect(() => {
    if (isSendForUpdate) {
      if (error) {
        message.error(t("employees.crud.form.error.edit") + " " + error);
      } else {
        message.success(t("employees.crud.form.edit.success"));
        onClose();
      }
      setIsSendForUpdate(false);
    }
  }, [isSendForUpdate, error]);

  const onSubmit = async (values) => {
    setError(null);
    setIsSendForUpdate(false);
    try {
      await updateSupplement(values, modalProps?.supplementId);
    } catch (error) {
      notification.error({
        message: t("employees.crud.form.error.edit"),
        description: error,
        role: "alert",
        duration: 3,
      });
    } finally {
      setIsSendForUpdate(true);
    }
  };

  const onClose = () => {
    form.resetFields();
    dispatch(closeModal());
  };
  return (
    <Modal
      title={
        <h4 style={{ textAlign: "center" }}>
          {t("supplements.crud.form.title.modification")}
        </h4>
      }
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose} className="custom-btn-1">
          {t("employees.crud.form.button.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="Supplement_Form"
          disabled={isLoading}
          className="custom-btn-2"
        >
          {t("employees.crud.form.button.save")}
        </Button>,
      ]}
      centered={true} 
      styles={{
        content: { overflowY: "auto", maxHeight: "75vh", width: "100%" },
      }}
    >
      <SupplementForm form={form} onSubmit={onSubmit} />
    </Modal>
  );
};

export default EditSupplementModal;
